import { IntroStep } from './IntroStep';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- child component rendered inside tracked UnsupportedMarketRoute
export const UnsupportedMarketPage = ({
  onNotifyMe,
}: {
  onNotifyMe: () => void;
}) => (
  <IntroStep
    data-testid="unsupported-market"
    data-track-id="region.unsupported-market"
    data-track-impression
    title="We're not in your country just yet"
    description="We're working on expanding Confidence to more countries. Select 'Notify me' to be the first to know when we make it to yours."
    buttonLabel="Notify me"
    onNext={onNotifyMe}
  />
);
